import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Speaker, Lightbulb, Mic2, Music2, Disc3, MonitorSpeaker } from "lucide-react";
import { useLang } from "@/context/LangContext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const iconMap = { Speaker, Lightbulb, Mic2, Music2, Disc3, MonitorSpeaker };

export default function Equipment() {
  const { t } = useLang();
  const [equipment, setEquipment] = useState([]);

  useEffect(() => {
    axios.get(`${API}/content/equipment`).then(r => setEquipment(r.data)).catch(() => {});
  }, []);

  if (!equipment.length) return null;

  return (
    <section id="equipement" className="relative py-16 md:py-32 bg-[#050505]" data-testid="equipment-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="mb-10 md:mb-16 text-center">
          <span className="text-[#E60000] text-xs sm:text-sm uppercase tracking-[0.3em] font-medium font-body">{t.equipment.section_tag}</span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold uppercase text-white mt-3" data-testid="equipment-title">
            {t.equipment.title} <span className="text-[#E60000]">{t.equipment.title_accent}</span>
          </h2>
          <p className="font-body text-[#A3A3A3] mt-4 max-w-2xl mx-auto">{t.equipment.subtitle}</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {equipment.map((item, i) => {
            const Icon = iconMap[item.icon] || Speaker;
            return (
              <motion.div key={item.id || i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08, duration: 0.5 }} className="group p-4 sm:p-6 border border-white/5 hover:border-[#E60000]/40 bg-[#0a0a0a] hover:bg-[#121212] transition-all duration-500" data-testid={`equipment-${i}`}>
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-[#E60000]/30 mb-3 sm:mb-4 group-hover:bg-[#E60000]/10 transition-colors">
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-[#E60000]" />
                </div>
                <h3 className="font-heading text-sm sm:text-lg font-bold uppercase text-white mb-1 sm:mb-2 tracking-tight">{item.title}</h3>
                <p className="font-body text-xs sm:text-sm text-[#A3A3A3] leading-relaxed">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
        <div className="mt-12 text-center">
          <p className="font-body text-white/50 text-sm mb-4">{t.equipment.bottom_text}</p>
          <button onClick={() => document.querySelector("#soumission")?.scrollIntoView({ behavior: "smooth" })} className="border border-[#E60000]/50 text-[#E60000] hover:bg-[#E60000] hover:text-white text-sm font-bold uppercase tracking-[0.15em] px-8 py-3.5 transition-all duration-300" data-testid="equipment-cta">
            {t.equipment.cta}
          </button>
        </div>
      </div>
    </section>
  );
}
